import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/salonbusinesscpa", label: "Dashboard" },
  { to: "/salonbusinesscpa/profile", label: "Profile" },
  { to: "/salonbusinesscpa/documents", label: "Documents" },
  { to: "/salonbusinesscpa/checklist", label: "Checklist" },
  { to: "/salonbusinesscpa/gst-hst", label: "GST/HST" },
  { to: "/salonbusinesscpa/payroll", label: "Payroll" },
  { to: "/salonbusinesscpa/bookkeeping", label: "Bookkeeping" },
];

export default function SalonBusinessCpaShell({
  title,
  description,
  actions,
  children,
}) {
  return (
    <div className="min-h-screen bg-[#f8f6f4] text-slate-950">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-5 py-4 lg:flex-row lg:items-center lg:justify-between">
          <Link to="/salonbusinesscpa" className="text-sm font-semibold text-slate-950">
            Ellyanna SalonBusinessCPA
          </Link>
          <nav className="flex gap-2 overflow-x-auto pb-1 lg:justify-end">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/salonbusinesscpa"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-full px-3 py-2 text-sm font-semibold ${
                    isActive
                      ? "bg-slate-950 text-white"
                      : "text-slate-600 hover:bg-slate-100 hover:text-slate-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-7xl space-y-6 px-5 py-8">
        <section className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
              Accounting portal
            </p>
            <h1 className="mt-2 text-3xl font-semibold text-slate-950 md:text-4xl">
              {title}
            </h1>
            {description ? (
              <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600">
                {description}
              </p>
            ) : null}
          </div>
          {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
        </section>

        {children}
      </main>
    </div>
  );
}

export function AccountingCard({ title, body, to, children }) {
  const content = (
    <article className="h-full rounded-3xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-slate-300">
      <h2 className="text-lg font-semibold text-slate-950">{title}</h2>
      {body ? <p className="mt-3 text-sm leading-6 text-slate-600">{body}</p> : null}
      {children ? <div className="mt-5">{children}</div> : null}
    </article>
  );

  return to ? (
    <Link to={to} className="block h-full">
      {content}
    </Link>
  ) : (
    content
  );
}
